import React, { useState } from "react";
import { withRouter, Link, useParams } from "react-router-dom";
import Constants from "../Constants";
const Pagination = ({ maxPages, history, path }) => {
  let { page } = useParams();
  if (!page) {
    page = 1;
  } else {
    page = parseInt(page);
  }
  const [gotoPage, setGotoPage] = useState("");
  const startPage = page - 5 <= 1 ? 1 : page - 5;
  const endPage = page + 5 >= maxPages ? maxPages : page + 5;
  const handleGoTo = () => {
    const pageNum = parseInt(gotoPage);
    if (!isNaN(pageNum)) history.push(`${Constants.HOME}${path}${pageNum}`);
  };
  const generateBefore = () => {
    if (page === startPage) {
      return;
    }
    let ret = [];
    //page 3
    //start page 1
    for (let i = 0; i < 5 && startPage + i < page; i++) {
      ret.push(
        <div className="item" key={`page${i}`}>
          <Link to={`${Constants.HOME}${path}${startPage + i}`}>
            {startPage + i}
          </Link>
        </div>
      );
    }
    return ret;
  };
  const generateAfter = () => {
    if (page === endPage) {
      return;
    }
    let ret = [];
    for (let i = 1; i <= 5 && page + i <= endPage; i++) {
      ret.push(
        <div className="item" key={`page${i}`}>
          <Link to={`${Constants.HOME}${path}${page + i}`}>{page + i}</Link>
        </div>
      );
    }
    return ret;
  };
  return (
    <div className="pagination">
      <div className="item pager">
        {page === 1 ? (
          <div className="pagenone">
            <i className="icon-arrow-left"></i>
          </div>
        ) : (
          <Link to={`${Constants.HOME}${path}${page - 1}`}>
            <i className="icon-arrow-left"></i>
          </Link>
        )}
      </div>
      {generateBefore()}
      <div className="item active">
        <span className="active">{page}</span>
      </div>
      {generateAfter()}
      <div className="item pager">
        {page === maxPages ? (
          <div className="pagenone">
            <i className="icon-arrow-right"></i>
          </div>
        ) : (
          <Link to={`${Constants.HOME}${path}${page + 1}`}>
            <i className="icon-arrow-right"></i>
          </Link>
        )}
      </div>
      {maxPages <= 5 ? null : (
        <div className="goto">
          <div className="item pager">
            <input
              type="text"
              placeholder={`page 1-${maxPages}`}
              className="gotoinput"
              value={gotoPage}
              onChange={(e) => setGotoPage(e.target.value)}
              onKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleGoTo();
                }
              }}
            />{" "}
            <span onClick={handleGoTo}>GoTo</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Pagination);
